export default __webpack_public_path__ + "static/media/print.button.5a5feb12.svg";